import './header_style.scss';
import Logo from "../../../assets/img_logo.png";
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import jQuery from 'jquery';
import { removeBaseUrl } from '../../../utils';

export const Header = ({
    menu,
    globalOptions
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isOpen,  setIsOpen] = useState(false);

    const openMobileMenu = () => {
        setIsOpen(true);
        document.body.classList.add('open-menu');
    }


    const closeMobileMenu = () => {
        setIsOpen(false);
        document.body.classList.remove('open-menu');
    }

    const checkMenuActivity = () => {
        const pathname = location.pathname;
        jQuery('ul#nav li.active').removeClass('active');
        jQuery('ul#nav a').each((it, element) => {
            const href = jQuery(element).attr('href');
            const locationPath = removeBaseUrl(href);
            if (locationPath === pathname || (pathname?.includes("/articles/") && locationPath?.includes("/articles/"))) {
                jQuery(element).closest('li.menu-item').addClass('active');
                jQuery(element).closest('li.menu-item-has-children').addClass('active');
            }
        });
    }

    useEffect(() => {
        setTimeout(() => {
            checkMenuActivity();
            jQuery('ul#nav a').on("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                const href = jQuery(this).attr('href')?.replace("https://www.alinealawpllc.com/", "");
                if (href?.length > 0) {
                    navigate(href);
                } else {
                    navigate("/");
                }
                if (jQuery(this).hasClass("search-icon")) {
                    navigate("/articles/");
                }

                if (href?.includes("#footer")) {
                    document.querySelector(".footer-form-wrapper").scrollIntoView({behavior: 'smooth', block: 'nearest'})
                }
                closeMobileMenu();
            });

            if (jQuery('li.menu-item-has-children>.arrow').length < 1) {
                jQuery(`<span class="arrow"> 
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_60_3372)">
                    <path d="M4.94 5.72668L8 8.78002L11.06 5.72668L12 6.66668L8 10.6667L4 6.66668L4.94 5.72668Z" fill="#FFF"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_60_3372">
                        <rect width="16" height="16" fill="#FFF"/>
                    </clipPath>
                    </defs>
                </svg>
                </span>`).insertAfter('li.menu-item-has-children>a');

                jQuery('li.menu-item-has-children>.arrow').click(function () {
                    jQuery(this).siblings('.sub-menu').slideToggle(200);
                });
            }
        }, 100)
    }, [menu]);

    useEffect(() => {
        checkMenuActivity();
    }, [location]);

    
    return <header id="header" className='header-section'>
        <div className='inner-wrapper'>
            <div className='logo'>
                <Link to="/">
                    <img src={Logo} />
                </Link>
            </div>
            <div className='btn-open-mobile-menu' onClick={() => {
                openMobileMenu();
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M4 6H20V8H4V6ZM4 11H16V13H4V11ZM4 16H20V18H4V16Z" fill="#FFF"></path>
                </svg>
            </div>
            <div className={`menu-content ${isOpen ? 'active' : ''}`}>
                <span className='btn-close' onClick={() => {
                    closeMobileMenu();
                }}>
                    &times;
                </span>
                {
                    menu && <div dangerouslySetInnerHTML={{__html: menu}} /> // 
                }
                {
                    !menu && <div className="menu-main-menu-container">
                        <ul id="nav">
                            <li><a href="#">Home</a></li>
                            <li><a href="#">About</a></li>
                            <li><a href="#">Practice Areas</a></li>
                            <li><a href="#">Blogs</a></li>
                            <li><a href="#">Resources</a></li>                            
                        </ul>
                    </div>
                }
                {
                    <a href="/contact-us" className='button btn-white'>Contact Us</a>
                }
                
            </div>
        </div>
    </header>
}